
/**
 * Quick add overlay — moves the existing "Choose options" / "Add to cart"
 * quick-add button on collection/product-grid cards from below the product
 * image onto the image itself, with two looks depending on the product:
 *
 *   - No variants to choose (button originally read "Add to cart"):
 *     a small transparent square with a "+" in the bottom-right corner
 *     of the image. Hover inverts to solid black with a white "+".
 *
 *   - Has variants to choose, e.g. size (button originally read
 *     "Choose options"): a full-width "Quick View" bar across the
 *     bottom of the image, transparent white background, black text.
 *
 * Built for the Dawn theme's product-card markup:
 *   .card-wrapper.product-card-wrapper
 *     .card
 *       .card__inner   (position: relative — this is the image box)
 *         .card__media
 *       .card__content
 *         .quick-add   (contains <modal-opener><button class="quick-add__submit">)
 *
 * This script does not change what the button does — it still opens the
 * same quick-add modal (variant picker, or just quantity + add for
 * single-variant products). It only relocates, restyles, and — for the
 * "Choose options" case — relabels it to "Quick View".
 *
 * INSTALL:
 * 1. Shopify admin → Online Store → Themes → your theme → "..." → Edit code
 * 2. In the Assets folder, open (or create) quick-add-overlay.js →
 *    paste this whole file → Save
 * 3. Open layout/theme.liquid, find the closing </body> tag near the bottom,
 *    and add this line just above it (skip if it's already there from a
 *    previous install):
 *      <script src="{{ 'quick-add-overlay.js' | asset_url }}" defer="defer"></script>
 * 4. Save theme.liquid, then preview a collection page.
 */
(function () {
  var STYLE_ID = 'quick-add-overlay-styles';
 
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      /* Dawn's card__inner has a CSS transform (used for its slide-in scroll
         animation), which creates a new stacking context. That traps our
         z-index inside it, so the theme's own full-card click overlay
         (.full-unstyled-link::after, z-index: 1) sits above our button and
         steals hover/click even though our button still paints visibly.
         Giving card__inner its own z-index lets its whole subtree (including
         our button) outrank that overlay. */
     '.card__inner {',
'  z-index: 2 !important;',
'  pointer-events: none;',
'}',
'.card__inner .quick-add,',
'.card__inner .quick-add * {',
'  pointer-events: auto;',
'}',
 
      '.quick-add--image-overlay {',
      '  position: absolute !important;',
      '  z-index: 2 !important;',
      '  margin: 0 !important;',
      '}',
      '.quick-add--image-overlay modal-opener {',
      '  display: block;',
      '}',
      '.quick-add--image-overlay .quick-add__submit .loading__spinner {',
      '  position: absolute;',
      '  inset: 0;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '}',
      '.quick-add--image-overlay .quick-add__submit .loading__spinner svg {',
      '  width: 18px;',
      '  height: 18px;',
      '}',
 
      /* ---- Icon variant: single-variant products ("Add to cart") ---- */
      '.quick-add--image-overlay.quick-add--icon {',
      '  right: 12px !important;',
      '  bottom: 12px !important;',
      '  left: auto !important;',
      '  top: auto !important;',
      '  width: auto !important;',
      '}',
      '.quick-add--image-overlay.quick-add--icon .quick-add__submit {',
      '  position: relative;',
      '  display: block;',
      '  width: 40px !important;',
      '  height: 40px !important;',
      '  min-width: 0 !important;',
      '  min-height: 0 !important;',
      '  padding: 0 !important;',
      '  margin: 0 !important;',
      '  border-radius: 0 !important;',
      '  background: transparent !important;',
      '  border: 1px solid currentColor !important;',
      '  color: #1a1a1a !important;',
      '  font-size: 0;',
      '  line-height: 1;',
      '  box-shadow: none !important;',
      '  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;',
      '}',
      '.quick-add--image-overlay.quick-add--icon .quick-add__submit::before,',
      '.quick-add--image-overlay.quick-add--icon .quick-add__submit::after {',
      '  content: "";',
      '  position: absolute;',
      '  top: 50%;',
      '  left: 50%;',
      '  background: currentColor;',
      '  transform: translate(-50%, -50%);',
      '}',
      '.quick-add--image-overlay.quick-add--icon .quick-add__submit::before {',
      '  width: 16px;',
      '  height: 2px;',
      '}',
      '.quick-add--image-overlay.quick-add--icon .quick-add__submit::after {',
      '  width: 2px;',
      '  height: 16px;',
      '}',
      '.quick-add--image-overlay.quick-add--icon .quick-add__submit:hover {',
      '  background: #000000 !important;',
      '  color: #ffffff !important;',
      '  transform: scale(1.08);',
      '}',
 
      /* ---- Bar variant: multi-variant products ("Choose options" -> "Quick View") ---- */
      '.quick-add--image-overlay.quick-add--bar {',
      '  left: 0 !important;',
      '  right: 0 !important;',
      '  bottom: 0 !important;',
      '  top: auto !important;',
      '  width: auto !important;',
      '}',
      '.quick-add--image-overlay.quick-add--bar .quick-add__submit {',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  width: 100% !important;',
      '  height: auto !important;',
      '  min-width: 0 !important;',
      '  min-height: 0 !important;',
      '  padding: 10px 12px !important;',
      '  margin: 0 !important;',
      '  border-radius: 0 !important;',
      '  border: none !important;',
      '  background: rgba(255, 255, 255, 0.82) !important;',
      '  color: #000000 !important;',
      '  font-size: 13px !important;',
      '  font-weight: 500 !important;',
      '  letter-spacing: 0.02em;',
      '  line-height: 1.2;',
      '  box-shadow: none !important;',
      '  transition: background 0.15s ease;',
      '}',
      '.quick-add--image-overlay.quick-add--bar .quick-add__submit:hover {',
      '  background: rgba(255, 255, 255, 0.95) !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }
 
  // Swaps the visible label text on a button to newLabel, leaving any
  // other markup inside it (like the hidden loading spinner) untouched.
  function relabel(btn, newLabel) {
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
    var replaced = false;
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim().length) {
        node.textContent = replaced ? '' : newLabel;
        replaced = true;
      }
    }
  }
 
  function moveButtons() {
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(function (card) {
      var inner = card.querySelector('.card__inner');
      var quickAdd = card.querySelector('.quick-add');
      if (!inner || !quickAdd) return;
      if (quickAdd.parentElement === inner) return; // already moved
 
      var btn = quickAdd.querySelector('.quick-add__submit');
      var hasVariants = !!btn && /choose options/i.test(btn.textContent);
 
      inner.appendChild(quickAdd);
      quickAdd.classList.add('quick-add--image-overlay');
 
      if (hasVariants) {
        quickAdd.classList.add('quick-add--bar');
        if (btn) relabel(btn, 'Quick View');
      } else {
        quickAdd.classList.add('quick-add--icon');
      }
    });
  }
 
  function init() {
    injectStyles();
    moveButtons();
  }
 
  document.addEventListener('DOMContentLoaded', init);
  // Re-run when Shopify's theme editor re-renders a section, or when
  // products are appended (e.g. a "load more" / infinite-scroll app).
  document.addEventListener('shopify:section:load', init);
  var observer = new MutationObserver(function () {
    moveButtons();
  });
  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
 


